// @flow
import { createContext } from 'react';

export const TooltipContext = createContext({ setData: () => {} });

export default TooltipContext;
